import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const VnPayResult = () => {
  const [status, setStatus] = useState<'success' | 'fail' | null>(null); // Trạng thái kết quả (success, fail)
  const [message, setMessage] = useState('');
  const [searchParams] = useSearchParams(); // Lấy query params từ URL
  const navigate = useNavigate();

  useEffect(() => {
    // Lấy vnp_ResponseCode từ URL để xác định giao dịch thành công hay thất bại
    const responseCode = searchParams.get('vnp_ResponseCode');

    if (responseCode === '00') {
      setStatus('success');
      setMessage('Giao dịch thành công! Cảm ơn bạn đã sử dụng dịch vụ.');
    } else {
      setStatus('fail');
      setMessage('Giao dịch thất bại. Vui lòng thử lại.');
    }

    // Tự động quay về trang chủ sau 5 giây
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);

    // Dọn dẹp timer khi component bị unmount
    return () => clearTimeout(timer);
  }, [searchParams, navigate]);

  return (
    <div
      className={`max-w-md mx-auto mt-20 p-6 rounded-lg shadow-lg text-center
      ${status === 'success' ? 'bg-green-50 border border-green-500' : 'bg-red-50 border border-red-500'}`}
    >
      {status === 'success' ? (
        <div className="text-green-600 mb-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-20 w-20 mx-auto"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <h2 className="text-2xl font-semibold mt-4">{message}</h2>
        </div>
      ) : (
        <div className="text-red-600 mb-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-20 w-20 mx-auto"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M18.364 5.636a9 9 0 11-12.728 12.728A9 9 0 0118.364 5.636zM15 9l-6 6m0-6l6 6"
            />
          </svg>
          <h2 className="text-2xl font-semibold mt-4">{message}</h2>
        </div>
      )}

      <p className="mt-2 text-gray-700">Mã giao dịch: {searchParams.get('vnp_TxnRef') || 'Không xác định'}</p>

      <p className="mt-2 text-sm text-gray-500">
        Bạn sẽ được chuyển về trang chủ sau <span className="font-semibold">5 giây</span>...
      </p>

      <button
        onClick={() => navigate('/')}
        className="mt-6 bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition duration-300"
      >
        Quay về trang chủ ngay
      </button>
    </div>
  );
};

export default VnPayResult;
